
import { ColorPaletteProp } from "@mui/joy";
import localforage from "localforage";
import IconMap from 'utils/icon_map';

export const getIcon = (name: string) => {
    // @ts-ignore: 7504
    const icon = IconMap[name];
    if (icon) {
        return icon;
    }
    return Error;
};


export const pluralize = (count: number, noun: string, suffix = 's') => {
    return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

export const money = (amount: number) => {
    return `$${amount.toFixed(2)}`;
}

export function capitalize(string: string) {
    if (typeof string !== 'string') return '';
    if (string.length === 0) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}


export const timeDuration = (duration: number, showSeconds=false) => {
    // Very simplified version of:
    // https://dockyard.com/blog/2020/02/14/you-probably-don-t-need-moment-js-anymore
    const locale = 'en-US';
    const paddedIntl = Intl.NumberFormat(locale, { minimumIntegerDigits: 2 })
    const og_duration = duration;
    duration = Math.abs(duration);
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor(duration / 60) % 60;
    const seconds = Math.ceil(duration % 60);
    if (!hours && !minutes && !showSeconds) {
        return "0m";
    }

    if(!(hours || minutes || seconds)) {
        return "0s";
    }

    return (
        (og_duration < 0 ? '-' : '') +
        (hours ? `${hours}h ` : '') +
            (minutes ? `${minutes}m ` : '') +
            (showSeconds && seconds ? `${paddedIntl.format(seconds)}s ` : ''));

};


export const phoneFormat = (number: string) => {
    const cleaned = ('' + number).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return number;
}

export const forageSet = async (key: string, value: any) => {
    return await localforage.setItem(key, value);
}

export const forageGet = async <T>(key: string): Promise<T | null> => {
    return await localforage.getItem<T>(key);
}

export const datetimeLocalFormat = (dateString: string | Date) => {
    // Format a date for use in a datetime-local input
    const d = new Date(dateString);

    const p  = (n: number) =>  ('0' + n).slice(-2);

    return d.getFullYear() + '-' +
        p(d.getMonth() + 1) + '-' +
        p(d.getDate()) + 'T' +
        p(d.getHours()) + ':' +
        p(d.getMinutes());

}


export const DedicatedRankingMap = (i: number | undefined) => {
    if (i === undefined) {
        i = -1;
    }
        switch (i) {
            case 1:
                return "primary";
            case 2:
                return "secondary";
            case 3:
                return "tertiary";
            default:
                return "#" + i;
        }
}



export const REQUEST_STATUS = {
    NEW: 1,
    AWAITING_MENTOR_APPROVAL: 3,
    MENTOR_RESPONSE: 4,
    OPEN: 5,
    AWAITING_RESPONSE: 7,
    CLIENT_RESPONSE: 10,
    AWAITING_THIRD_PARTY: 11,
    AWAITING_MANAGER_RESPONSE: 12,
    THIRD_PARTY_RESPONSE: 13,
    CLOSED: 20,
    EXPIRED: 21,
    ARCHIVED: 22,
    NAME: (status: number) => {
        switch (status) {
            case REQUEST_STATUS.NEW:
                return "New";
            case REQUEST_STATUS.AWAITING_MENTOR_APPROVAL:
                return "Awaiting Mentor Approval";
            case REQUEST_STATUS.MENTOR_RESPONSE:
                return "Mentor Response";
            case REQUEST_STATUS.OPEN:
                return "Open";
            case REQUEST_STATUS.AWAITING_RESPONSE:
                return "Awaiting Response";
            case REQUEST_STATUS.CLIENT_RESPONSE:
                return "Client Response";
            case REQUEST_STATUS.AWAITING_THIRD_PARTY:
                return "Awaiting Third Party";
            case REQUEST_STATUS.AWAITING_MANAGER_RESPONSE:
                return "Awaiting Manager Response";
            case REQUEST_STATUS.THIRD_PARTY_RESPONSE:
                return "Third Party Response";
            case REQUEST_STATUS.CLOSED:
                return "Closed";
            case REQUEST_STATUS.EXPIRED:
                return "Expired";
            case REQUEST_STATUS.ARCHIVED:
                return "Archived";
            default:
                return "Unknown: " + status;
        }
    },
    COLOR: (status: number): ColorPaletteProp => {
        switch (status) {
            case REQUEST_STATUS.NEW:
                return "success";
            case REQUEST_STATUS.OPEN:
                return "success";
            case REQUEST_STATUS.AWAITING_RESPONSE:
                return "neutral";
            case REQUEST_STATUS.CLIENT_RESPONSE:
                return "warning";
            case REQUEST_STATUS.AWAITING_THIRD_PARTY:
                return "neutral";
            case REQUEST_STATUS.AWAITING_MANAGER_RESPONSE:
                return "neutral";
            case REQUEST_STATUS.THIRD_PARTY_RESPONSE:
                return "warning";
            case REQUEST_STATUS.CLOSED:
                return "neutral";
            case REQUEST_STATUS.EXPIRED:
                return "neutral";
            case REQUEST_STATUS.ARCHIVED:
                return "neutral";
            default:
                return "neutral";
        }
    }

};

export const REQUEST_SOURCE = {
    EMAIL: 1,
    WEB: 2,
    API: 3,
    PHONE: 4,
    BASECAMP: 5,
    DO: 6,
    BEER: 7,
    INCOMING: 8,
    CALLNUT: 9,
    PUBLIC_API: 10,
    SIMPLE_WEB: 11,
    RECURRING: 12,
    ORRI: 13,
    ADMIN_TUTORIAL: 14,
    SMS: 15,
    REALTIME_API: 16,
    TRYOUT: 17,
    FB_MESSENGER: 18,
    MORTY: 19,
    ODO_APPLICATION: 20,
    DAYONES_WEB: 21,
    DAYONES_EMAIL: 22,
    DAYONES_PHONE: 23,
    NAME: (source: number) => {
        switch (source) {
            case REQUEST_SOURCE.EMAIL:
                return "Email";
            case REQUEST_SOURCE.WEB:
                return "Web";
            case REQUEST_SOURCE.API:
                return "API";
            case REQUEST_SOURCE.PHONE:
                return "Phone";
            case REQUEST_SOURCE.BASECAMP:
                return "Basecamp";
                case REQUEST_SOURCE.DO:
                return "DO";
            case REQUEST_SOURCE.BEER:
                return "Beer";
            case REQUEST_SOURCE.INCOMING:
                return "Incoming";
            case REQUEST_SOURCE.CALLNUT:
                return "Callnut";
            case REQUEST_SOURCE.PUBLIC_API:
                return "Public API";
            case REQUEST_SOURCE.SIMPLE_WEB:
                return "Original Website";
            case REQUEST_SOURCE.RECURRING:
                return "Recurring";
            case REQUEST_SOURCE.ORRI:
                return "ORRI";
            case REQUEST_SOURCE.ADMIN_TUTORIAL:
                return "Admin Tutorial";
            case REQUEST_SOURCE.SMS:
                return "SMS";
            case REQUEST_SOURCE.REALTIME_API:
                return "Realtime API";
            case REQUEST_SOURCE.TRYOUT:
                return "Tryout";
            case REQUEST_SOURCE.FB_MESSENGER:
                return "FB Messenger";
            case REQUEST_SOURCE.MORTY:
                return "App";
            case REQUEST_SOURCE.ODO_APPLICATION:
                return "ODO Application";
            case REQUEST_SOURCE.DAYONES_WEB:
                return "Web";
            case REQUEST_SOURCE.DAYONES_EMAIL:
                return "Email";
            case REQUEST_SOURCE.DAYONES_PHONE:
                return "Day Ones Phone";
            default:
                return "Unknown: " + source;
        }
    }
};

export const clock_duration_color = (seconds: number, default_color?: ColorPaletteProp) => {
    const WARNING_LEVEL = 20 * 60;
    const DANGER_LEVEL = 60 * 60;
    let color = default_color;
    if (seconds >= DANGER_LEVEL)
        color = 'danger';
    else if (seconds >= WARNING_LEVEL)
        color = 'warning';
    return color
}
